import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../UI/Button/Button';
import { LeftArrowIcon, RightArrowIcon } from '../../../assets/icons';
import richText from '../../../assets/scss/richText.module.scss';
import { Loader } from '../../../components/Loader/Loader';
import { PageLayout } from '../../../components/PageLayout/PageLayout';
import { PagePagination } from '../../../components/PagePagination/PagePagination';
import { Tag } from '../../../components/Tag/Tag';
import { formatPublishDate } from '../../../helpers/article';
import { axiosInstance } from '../../../helpers/axios';
import { useWindowWidth } from '../../../hooks/useWindowWidth';
import { PATH_DASHBOARD } from '../../../routes/RouterConfig';
import { IArticle } from '../../../types/types';
import styles from './UsefulItemPage.module.scss';

export const UsefulItemPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const windowWidth = useWindowWidth();
    const [article, setArticle] = useState<IArticle | null>(null);

    useEffect(() => {
        axiosInstance
            .get(`/v1/article/${id}/`)
            .then((response) => setArticle(response.data))
            .catch((error) => console.error(error));
    }, [id]);

    const goTo = (articleId: number) => navigate(`/useful/${articleId}`);
    const isWide = Boolean(windowWidth && windowWidth > 650);

    return (
        <PageLayout>
            <div className={styles.page}>
            <section className={styles.article}>
                <PagePagination
                    linkName="Полезное"
                    route={PATH_DASHBOARD.useful}
                    event={article?.title}
                />
                {article ? (
                    <>
                        <div className={styles.article__title}>
                            <Tag
                                type="rubric"
                                content={article.rubric.title}
                            />
                            <h2 className={styles.article__header}>
                                {article.title}
                            </h2>
                            <p className={styles.article__date}>
                                Дата публикации:{' '}
                                {formatPublishDate(article.publish_date)}
                            </p>
                        </div>
                        {article.image ? (
                            <div className={styles.article__cover}>
                                <img
                                    className={styles.article__image}
                                    src={article.image}
                                    alt=""
                                />
                            </div>
                        ) : null}
                        <div
                            className={cn(
                                richText.richText,
                                styles.article__text,
                            )}
                            // HTML очищен на бэкенде при сохранении: в нём только
                            // то, что умеет редактор, без скриптов и атрибутов
                            dangerouslySetInnerHTML={{ __html: article.text }}
                        />
                        <div className={styles.article__buttons}>
                            {article.previous_article ? (
                                <Button
                                    className={styles.article__button}
                                    onClick={() =>
                                        goTo(article.previous_article!)
                                    }
                                >
                                    {isWide ? (
                                        <p>К предыдущему материалу</p>
                                    ) : (
                                        <LeftArrowIcon />
                                    )}
                                </Button>
                            ) : null}
                            {article.next_article ? (
                                <Button
                                    className={cn(
                                        styles.article__button,
                                        styles.article__button_next,
                                    )}
                                    onClick={() => goTo(article.next_article!)}
                                >
                                    {isWide ? (
                                        <p>К следующему материалу</p>
                                    ) : (
                                        <RightArrowIcon />
                                    )}
                                </Button>
                            ) : null}
                        </div>
                    </>
                ) : (
                    <div className={styles.article__loader}>
                        <Loader />
                    </div>
                )}
            </section>
            </div>
        </PageLayout>
    );
};
